import { combineReducers } from 'redux';
import userReducer from "./features/users/UserSlice"
import precustomerReducer from "./features/precustomers/PrecustomerSlice"
import bundleReducer from './features/bundles/BundleSlice';
import regionReducer from './features/regions/regionSlice';
import deviceCategoryReducer from './features/devices/deviceCategorySlice';
import modalSlice from './features/modalAlert.js/modalSlice';
import customerStatus from './features/customerStatus/customerStatus';
import onboardingDetails from './features/customerStatus/onboardingDetails';
import oxygenRetailSlice from "./features/oxygen/oxygenRetailSlice";
import customModalSlice from "../redux/features/oxygen/customModalSlice";

const persistentReducers = combineReducers({
    user: userReducer,
    precustomer: precustomerReducer,
    bundles: bundleReducer,
    regions: regionReducer,
    deviceCategories: deviceCategoryReducer,
    modal: modalSlice,
    customersStatus: customerStatus,
    onboardingDetails: onboardingDetails,
    oxygenRetail: oxygenRetailSlice,
    customModal: customModalSlice,
});

export default persistentReducers;
